import React from 'react';
import { shallow } from 'zustand/shallow';
import { Overlay, Heading } from '@rivallapp/volosports-components';

import { useUrlParams } from '../../../../../../hooks';
import { useDiscoverStore } from '../../../../../../zustand-stores';
import { NumberOfPeopleFilter } from '../../../../../../shared-components/feature-components';

type Props = {
  visible: boolean;
  onClose: () => void;
};

const PlayWithFriendsModal: React.FC<Props> = ({ visible, onClose }) => {
  const { updateUrlParams } = useUrlParams();

  const { minimumMen, minimumWomen, minimumNonBinary } = useDiscoverStore(
    store => ({
      minimumMen: store.filters.minimumMen,
      minimumWomen: store.filters.minimumWomen,
      minimumNonBinary: store.filters.minimumNonBinary,
    }),
    shallow
  );

  return (
    <Overlay
      show={visible}
      close={onClose}
      size="md"
      safeAreaTop
      modalStyle={{ marginTop: 54, justifyContent: 'flex-start' }}
    >
      {/* TODO: This margin is hacky. The `<Overlay>` component doesn't provide allow you to pass `<Modal.Header>`, which would automatically align this without hacks. */}
      <Heading size="sm" color="primary.600" type="subsection" marginY={1} marginBottom={5}>
        Number of People
      </Heading>
      <NumberOfPeopleFilter
        minimumMen={minimumMen}
        minimumWomen={minimumWomen}
        minimumNonBinary={minimumNonBinary}
        onChangeMinimumMen={value => updateUrlParams({ minimumMen: value || undefined })}
        onChangeMinimumWomen={value => updateUrlParams({ minimumWomen: value || undefined })}
        onChangeMinimumNonBinary={value =>
          updateUrlParams({ minimumNonBinary: value || undefined })
        }
      />
    </Overlay>
  );
};

export default PlayWithFriendsModal;
